import React, {ComponentProps} from 'react'
import {MBMemberInput} from './MBMemberInput'

type Props = ComponentProps<typeof MBMemberInput> & {
  type?: never
  autoComplete?: never
  className?: never,
}
export const MBMemberEMailInput: React.VFC<Props> = props =>
  <MBMemberInput
    {...props}
    type={'email'}
    autoComplete={'email'}
    className={'form-text_01 w_100 pc100'}
  />
